import { trustPills } from './config'

function HomepageTrustBar() {
    return (
        <section
            id="industries"
            className="scroll-mt-24 border-y border-black/10 bg-[#FFF9F2] py-3.5">
            <div className="container mx-auto flex flex-wrap items-center gap-5 px-5 md:px-0">
                <span className="whitespace-nowrap text-[11px] font-bold uppercase tracking-[0.05em] text-[#6F7785]">
                    Trusted across industries
                </span>
                {trustPills.map((pill) => (
                    <div
                        key={pill.label}
                        className="flex items-center gap-1.5 text-xs text-[#6F7785] opacity-80 font-semibold">
                        <span
                            className={`flex h-5 w-5 items-center justify-center rounded text-[12px] leading-none ${pill.badgeClass}`}>
                            {pill.icon}
                        </span>
                        <span>{pill.label}</span>
                    </div>
                ))}
                <div className="ml-auto flex items-center gap-2 border-l border-black/10 pl-5">
                    <svg
                        width="24"
                        height="24"
                        viewBox="0 0 34 34"
                        fill="none"
                        aria-hidden="true">
                        <rect width="34" height="34" rx="7" fill="#F28230" />
                        <text
                            x="17"
                            y="13.5"
                            textAnchor="middle"
                            fontFamily="'Plus Jakarta Sans', sans-serif"
                            fontWeight="800"
                            fontSize="7"
                            fill="white">
                            INC.
                        </text>

                        <text
                            x="17"
                            y="24"
                            textAnchor="middle"
                            fontFamily="'Plus Jakarta Sans', sans-serif"
                            fontWeight="800"
                            fontSize="9.5"
                            fill="white">
                            5000
                        </text>
                    </svg>
                    <span className="text-xs font-bold text-[#4A5160]">
                        Inc. 5000
                    </span>
                </div>
            </div>
        </section>
    )
}

export default HomepageTrustBar
